import React from 'react';
import { KeyRound } from 'lucide-react';
import { Page, PageHeader, SectionCard } from '../../components/ui';
import TwoFactorSettings from '../../components/security/TwoFactorSettings';
import { useAuth } from '../../context/AuthContext';

// My account › Security. Two-factor sign-in belongs to the person, not the organisation, so it lives
// here where every web role can reach it — Settings is admin-only, and an office user the
// organisation requires 2FA of otherwise had nowhere to enrol before the setup period ran out.
export default function AccountSecurity() {
  const { user } = useAuth();
  return (
    <Page>
      <PageHeader
        title="Security"
        description="Protect your sign-in with a second step from an authenticator app on your phone."
      />
      <SectionCard title="Two-factor authentication" icon={KeyRound} bodyClass="px-5 py-4">
        {user?.impersonating ? (
          <p className="text-sm text-slate-500">
            Two-factor sign-in belongs to a person. It isn't available while you are viewing an organisation.
          </p>
        ) : (
          <TwoFactorSettings />
        )}
      </SectionCard>
    </Page>
  );
}
